type TapeColor = "yellow" | "mint" | "pink" | "purple";
type TapePosition = "top" | "bottom" | "left" | "right";

interface MaskingTapeProps {
  color?: TapeColor;
  position?: TapePosition;
  width?: string;
  className?: string;
}

const colorStyles: Record<TapeColor, string> = {
  yellow: `repeating-linear-gradient(
    45deg,
    rgba(253, 224, 71, 0.6),
    rgba(253, 224, 71, 0.6) 10px,
    rgba(253, 224, 71, 0.3) 10px,
    rgba(253, 224, 71, 0.3) 20px
  )`,
  mint: `repeating-linear-gradient(
    45deg,
    rgba(110, 231, 183, 0.6),
    rgba(110, 231, 183, 0.6) 10px,
    rgba(110, 231, 183, 0.3) 10px,
    rgba(110, 231, 183, 0.3) 20px
  )`,
  pink: `repeating-linear-gradient(
    45deg,
    rgba(249, 168, 212, 0.6),
    rgba(249, 168, 212, 0.6) 10px,
    rgba(249, 168, 212, 0.3) 10px,
    rgba(249, 168, 212, 0.3) 20px
  )`,
  purple: `repeating-linear-gradient(
    45deg,
    rgba(167, 139, 250, 0.6),
    rgba(167, 139, 250, 0.6) 10px,
    rgba(167, 139, 250, 0.3) 10px,
    rgba(167, 139, 250, 0.3) 20px
  )`,
};

const positionStyles: Record<TapePosition, string> = {
  top: "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2",
  bottom: "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2",
  left: "left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 rotate-90",
  right: "right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-90",
};

export function MaskingTape({
  color = "yellow",
  position = "top",
  width = "80px",
  className = "",
}: MaskingTapeProps) {
  return (
    <div
      className={`absolute h-6 rounded-sm shadow-sm z-10 ${positionStyles[position]} ${className}`}
      style={{
        background: colorStyles[color],
        width,
      }}
    />
  );
}

export type { MaskingTapeProps, TapeColor };
